import { IGauthReq } from '../data-hooks/auth-api';

export const loginGoogleAuth = (email: string | undefined = '', accessToken: string | undefined = ''): IGauthReq => {
  return { chain: 'OTHER', email, accessToken };
};
